import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Header from 'containers/components/layouts/Header';
import HeaderTitle from 'containers/components/layouts/HeaderTitle';
import HeaderSection from 'containers/components/layouts/HeaderSection';
import HeaderSectionDefault from 'containers/components/layouts/HeaderSectionDefault';

const CampaignsHeader = React.memo(() => {
    const location = useLocation();

    const titleKey = useMemo(() => {
        if (location.pathname.startsWith('/campaigns/marketing')) {
            return 'label_email_campaigns';
        }
        return 'label_sales_campaigns';
    }, [location.pathname]);

    return (
        <Header>
            <HeaderSection>
                <HeaderTitle title={titleKey} />
            </HeaderSection>
            <HeaderSectionDefault />
        </Header>
    );
});

CampaignsHeader.displayName = 'CampaignsHeader';

export default CampaignsHeader;
